import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationControlsModule } from 'app/layout/common/custom-pagination/custom-pagination.module';
import { COMMON_DIRECTIVES } from './services/common-directives';
import { NoOnlySpacesDirective } from './directive/NoOnlySpacesDirective ';





@NgModule({
    declarations: [NoOnlySpacesDirective,...COMMON_DIRECTIVES],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PaginationControlsModule,
    ],
   
    exports: [
        CommonModule,
        FormsModule,
        NoOnlySpacesDirective,
        ReactiveFormsModule,
        PaginationControlsModule,
        ...COMMON_DIRECTIVES
    ]
})
export class SharedModule
{
}
